import type { ReactNode } from 'react';

type Props = {
  eyebrow: string;
  title: string;
  intro: string;
  children: ReactNode;
};

export function LegalDocumentLayout({ eyebrow, title, intro, children }: Props) {
  return (
    <div className="legal-document-page">
      <header className="legal-document-hero">
        <div className="site-container legal-document-hero__inner">
          <p className="eyebrow">{eyebrow}</p>
          <h1>{title}</h1>
          <p>{intro}</p>
        </div>
      </header>

      <main className="site-container legal-document-main">
        <aside className="legal-draft-notice" role="note" aria-label="Estado del documento">
          <strong>Documento preliminar para validación legal.</strong>
          <span>
            Este contenido refleja el funcionamiento técnico auditado del sitio y datos corporativos presentes en el proyecto.
            Debe ser revisado y aprobado legalmente antes de considerarse la versión definitiva.
          </span>
        </aside>

        <article className="legal-document-content">
          {children}
        </article>
      </main>
    </div>
  );
}
